import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20green%20and%20gold%20lighting%2C%20abstract%20motion%20blur%20of%20athletes%2C%20dark%20elegant%20background%20with%20stadium%20lights%2C%20cinematic%20wide%20shot%2C%20professional%20sports%20photography%20style%2C%20luxurious%20dark%20green%20and%20warm%20gold%20tones&width=1800&height=900&seq=kaiyun-hero-bg&orientation=landscape"
          alt="开云体育官方下载 - 体育竞技平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <i className="ri-verified-badge-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs md:text-sm text-primary-200 font-medium">官方正版 · 安全认证 · 全球千万用户信赖</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            开云体育
            <span className="block text-primary-400 mt-1">官方正版App下载</span>
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            {siteConfig.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-primary-500 text-background-50 font-semibold text-base transition-all duration-300 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-apple-line text-xl w-5 h-5 flex items-center justify-center"></i>
              iOS 下载
            </a>
            <a
              href="#download"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-accent-500 text-foreground-950 font-semibold text-base transition-all duration-300 hover:bg-accent-600 dark:text-foreground-950 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-android-line text-xl w-5 h-5 flex items-center justify-center"></i>
              安卓 下载
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-xs text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line w-3.5 h-3.5 flex items-center justify-center"></i>
              SSL加密传输
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-smartphone-line w-3.5 h-3.5 flex items-center justify-center"></i>
              iOS + Android
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-download-cloud-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
              免费下载
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-customer-service-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
              7x24小时客服
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}